/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import React from 'react';

// Core
import { Router } from '@app';
import { Button } from '@client/components';

// App
import useHeader from '@client/pages/useHeader';
import Page from '@/client/pages/convert/_layout/page';

/*----------------------------------
- CONTROLEUR
----------------------------------*/
Router.error( 500, { layout: 'convert' }, ({ data }) => {
    return (
        <Page title="Technical Error" description={data.message}>

            <div class="col al-center">

                <div class="card col al-center w-a-4">

                    <i src="times-circle" class="xxl fg error" />

                    <h1>Technical Error</h1>

                    <p>{data.message}</p>

                    Do you think this is not normal?

                    <Button type="primary" link="https://wa.me/330601711555">
                        Report to the team
                    </Button>
                </div>
            </div>
        </Page>
    )
});